import React from 'react';
import { Chip } from '@mui/material';
import MeetingRoomOutlinedIcon from '@mui/icons-material/MeetingRoomOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import { useTranslation } from 'react-i18next';
import type { PassTargetType } from '../../models/Pass';
import { passTargetTypeShortLabel } from '../../utils/passFormatting';
import { passMetaChipSx } from './passDetailLayout';

export interface PassTargetTypeChipProps {
  targetType: PassTargetType;
  size?: 'small' | 'medium';
  sx?: React.ComponentProps<typeof Chip>['sx'];
}

/** Compact chip distinguishing ROOM vs LESSON_OPTION passes. */
const PassTargetTypeChip: React.FC<PassTargetTypeChipProps> = ({ targetType, size = 'small', sx }) => {
  const { t } = useTranslation();
  const isRoom = targetType === 'ROOM';
  const icon = isRoom ? (
    <MeetingRoomOutlinedIcon aria-hidden />
  ) : (
    <SchoolOutlinedIcon aria-hidden />
  );

  return (
    <Chip
      size={size}
      variant="outlined"
      icon={icon}
      label={passTargetTypeShortLabel(targetType, t)}
      sx={{
        ...passMetaChipSx,
        ...sx,
      }}
    />
  );
};

export default PassTargetTypeChip;
